import React from "react";

const HeroStatCard = ({ icon: Icon, value, label }) => {
  return (
    <div className="rounded-3xl border border-white/15 bg-white/10 p-4 shadow-lg shadow-black/10 backdrop-blur">
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-2xl bg-orange-400/15 text-orange-200 ring-1 ring-orange-300/20">
        {Icon && <Icon className="h-5 w-5" />}
      </div>

      <div className="text-2xl font-bold text-white">{value}</div>

      <p className="mt-1 text-sm leading-snug text-slate-300">{label}</p>
    </div>
  );
};

export default HeroStatCard;